export default {
  agreementName: lang.templateByUuid("UID:P_UDHWN_17DD50DE0500046B","协议名称") /* "协议名称" */,
  agreementContent: lang.templateByUuid("UID:P_UDHWN_17DD50DE0500046C","内容") /* "内容" */,
  warringMessage1: lang.templateByUuid("UID:P_UDHWN_17DD50DE0500046D","请填写协议名称!") /* "请填写协议名称!" */,
  warringMessage2: lang.templateByUuid("UID:P_UDHWN_17DD50DE0500046E","请填写协议内容!") /* "请填写协议内容!" */
};
